// A API de pacientes ainda não traz triagens, etapa, status nem vencimento:
// esses campos ficam vazios e a tabela mostra "-".
export const normalizePatients = (apiPatients = []) =>
  apiPatients.map((patient) => ({
    id: patient.patient_sub,
    name: patient.name,
    screeningsCount: null,
    stage: null,
    createdAt: patient.date_created,
    screeningStatus: null,
    expiration: null,
    screenings: [],
  }));
